import { render } from "./LicenseApplicationFormEditor.vue?vue&type=template&id=bfa58c0a"
import script from "./LicenseApplicationFormEditor.vue?vue&type=script&lang=js"
export * from "./LicenseApplicationFormEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__